export { default } from './Manufacturer'
